import { DetailsItem as Item } from '@calendly/booking-kit'
import { IconUsers } from '@calendly/ui/components/glyphs/IconUsers'
import { UiIcon } from '@calendly/ui/components/ui-icon'

export default ({ items }) => items.length > 1 && (
  <Item>
    <UiIcon icon={IconUsers} size="medium" spacingRight="8" />
    {items.join(', ')}
  </Item>
)
